const local = {
  api: 'https://delta-elektronika.lndo.site/api/v1-0',
};
const development = {
  api: 'https://delta-elektronika.nilssonweb.nl/api/v1-0',
};
const production = {
  api: 'https://www.delta-elektronika.nl/api/v1-0',
};

let config = process.env.NODE_ENV === 'production' ? production : development;
if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('lndo.site') !== -1) {
  config = local;
  console.log('Local environment detected. Using local settings.');
} else if (window.location.hostname.indexOf('delta-elektronika.nilssonweb.nl') !== -1) {
  config = development;
  console.log('Staging environment detected. Using development settings.');
}

export default {
  ...config,
};
